import React from 'react';

import ErrorScreen from 'components/ErrorScreen/ErrorScreen';
import FriendlyScreen from 'components/FriendlyScreen/FriendlyScreen';
import Spinner from 'components/SpinnerView/SpinnerView';
import useUserPermissions from 'hooks/useUserPermissions';
import { useAppSelector } from 'utils/hooks/useAppSelector';

interface IAuthProvider {
  permission: string | string[];
  children: React.ReactNode;
  showFriendlyScreen?: boolean;
  showErrorScreen?: boolean;
}

const AuthProvider: React.FC<IAuthProvider> = ({
  children,
  permission,
  showFriendlyScreen,
  showErrorScreen,
}) => {
  const loadingOnboard = useAppSelector(
    (state) => state.userOnboardDetails.isLoading
  );

  const isLoadingUserPermissions = useAppSelector(
    (state) => state.userPermission.isLoading
  );

  const hasPermission = useUserPermissions({ permission });

  if (isLoadingUserPermissions)
    return (
      <Spinner spinning={true}>
        <div className="w-full h-full"> </div>
      </Spinner>
    );
  if (showErrorScreen) return <ErrorScreen />;
  if (!hasPermission && showFriendlyScreen) return <FriendlyScreen />;

  if (hasPermission) return children;
  return <></>;
};

export default AuthProvider;
